import * as React from 'react';
import List from 'components/AssetList';
import Header from 'components/AssetList/Header';
import { useToggle } from 'components/AssetList/hooks';
import StoryCard from 'components/AssetsCollection';
import { EntityType } from 'const';
import { ModuleBundleMap } from 'models';
import { intlGet } from 'utils/intlGet';
import { IModuleBundleListProps } from './models';

const ModuleBundleList: React.FunctionComponent<IModuleBundleListProps> = (props) => {
  const {
    items,
    showUpdatedModuleBundles,
    toggleUpdatedDocumentsDisplaying,
    updatedInPromoMats,
    dataTestId = 'moduleBundleList',
  } = props;

  const {
    expanded,
    toggle,
  } = useToggle({
    toggleUpdatedDocumentsDisplaying,
    showUpdatedDocuments: showUpdatedModuleBundles,
    entityType: EntityType.MODULE_BUNDLE,
  });

  const hasItems = items && items.size > 0;

  if (!hasItems) {
    return null;
  }

  return (
    <div data-title="module-bundles" data-testid={dataTestId}>
      <Header
        title={intlGet('Assets', 'ModuleBundles', { count: items.size })}
        showUpdatesHint={updatedInPromoMats && showUpdatedModuleBundles}
        expanded={expanded}
        onClick={toggle}
        dataTestId={`${dataTestId}-header`}
      />
      {
        expanded &&
        <List
          elements={items}
          renderElement={(moduleBundle: ModuleBundleMap, index: number): React.ReactNode => (
            <StoryCard key={moduleBundle.get('id')} document={moduleBundle} dataTestId={`${dataTestId}-list${index}`} />
          )}
          dataTestId={`${dataTestId}-list`}
        />
      }
    </div>
  );
};

export default ModuleBundleList;
